// extracted by mini-css-extract-plugin
module.exports = {"project_edit":"FJProjectName_project_edit__r14hW","input":"FJProjectName_input__13wol","active":"FJProjectName_active__39SaQ"};